import type { EquipmentResourceFailure } from '~/client/src/shared/resources/domain/equipmentResourceTypeDefinition'
import type { ResourceResult } from '~/client/src/shared/resources/domain/resourceResult'

/** Translates a typed Equipment failure at React's rejected-promise seam. */
export function requireEquipmentResourceSuccess<T>(
  result: ResourceResult<T, EquipmentResourceFailure>,
): T {
  if (result._tag === 'Ok') return result.value
  if (
    result.error._tag === 'ProjectResourceOperationFailure' &&
    result.error.cause instanceof Error
  ) {
    throw result.error.cause
  }
  throw new Error(
    result.error._tag === 'MissingEquipmentResourceRecord'
      ? `Cannot save missing Equipment: ${result.error.recordId}`
      : result.error._tag === 'MissingEquipmentResourceId'
        ? 'Equipment response did not contain an id'
        : `Equipment operation failed: ${result.error.operation}`,
  )
}
